import axios from "axios";

export const live_api_domain = 'https://api.ouja.in/';
export const development_api_domain = 'http://ouja.clusterbooks.com/';

export const apiInstance = axios.create({
    baseURL: process.env.NODE_ENV === `development` ? live_api_domain : live_api_domain,
});

// commmon action for all http requests
// name: name of request (string)
// config: http config(s) (object, array);
export const httpAction = (name, config) => {
    let isConfigArray = Array.isArray(config);
    return async dispatch => {
        let result;
        dispatch({
            type: `${name}_FETCHING`
        })
        try {
            if(isConfigArray){
                result = await Promise.all(config.map(conf => apiInstance(conf)))
            } else {
                result = await apiInstance(config)
            }
            dispatch({
                type: `${name}_FULFILLED`,
                payload: isConfigArray ? 
                  result.map(x => x.data)  
                : result.data || "success"
            })
        } catch (err) {
            dispatch({
                type: `${name}_REJECTED`,
                payload: err.response ? err.response.data : "Something went wrong"
            })
            if(err.response){
                if(err.response.status === 401){
                    dispatch({
                        type: "LOGOUT_FULFILLED"
                    })
                }
            }
        }
    }
}   

export const getproductitems_api = "master/product-items/";
export const master_api = "master/";
export const facebookauth_api = "auth/facebook-login/";
export const googleauth_api = "auth/google-login/";
export const createorder_api = "orders/create_order/";
export const orders_api = "orders/";
export const offers_api = "offer/";
export const estimateprice_api = "orders/calculate_cost/";
export const updateprofile_api = "auth/profile/";
export const onlinepay_api = "orders/payment_success/";
export const mastervalues_api = "master/values/";
export const logout_api = "auth/logout/";
export const ratecard_api = "master/rate-card/";
export const contact_api = "master/contact-us/";
export const becomeapartner_api = "master/become-our-partner/"

//store apis
export const store_orders_api = "orders/store";
export const store_login_api = "auth/login/store/";
export const store_details_api = "stores/";
export const store_packages_api = "stores/packages/";
export const changepwd_api = "auth/change-password/";
export const store_purchase_online_api = "stores/packages/payment_success/";
export const store_book_api = "orders/store/";

//get product items
export const getProductItems = () => apiInstance({
    "url": getproductitems_api,
    "method": "GET",
})

export const loadLocalState = () => {
    try {
        const serializedState = localStorage.getItem('user');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveLocalState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('user', serializedState);
    } catch (err) {
        // Ignore write errors.
    }
};

export const ajaxerrmsg = (res) => {
    var txt = '';
    if (res && typeof(res) === "object" ) {
        let data = res;
        for (var key in data) {
            txt += key + " - ";
            if (data[key].non_field_errors) {
                if (Array.isArray(data[key].non_field_errors)) {
                    txt += data[key].non_field_errors[0].replace("This field", key) + " ";
                } else {
                    txt += data[key].non_field_errors + ". ";
                }
            } else {
                if (Array.isArray(data[key])) {
                    txt += data[key][0].replace("This field", key) + " ";
                } else {
                    txt += data[key] + " ";
                }
            }
        }
    } else {
        txt = "Something went wrong";
    }
    return txt.replace("non_field_errors -", "");
}

export const RZPay = (order, user, handleResponse) =>{
    const options = {
        "key": order.razorpay_api_key || "rzp_test_f3FHkjOtss1jX5",
        "amount": order.amount || order.pay_amount, 
        "name": "Ouja",
        "description": "Ouja payment",
        "order_id": order.order_id || order.razorpay_order_id,
        "currency": "INR",
        // "image": "/your_logo.png",
        "handler": function(response){
            handleResponse(response)
        },
        "prefill": {
            "name": user.first_name,
            "email": user.email,
            "contact": user.username 
        },
        "theme": {
            "color": "#F37254"
        }
    };
    const rzp1 = new window.Razorpay(options);
    rzp1.open();
}